export default "__VITE_ASSET__b0e4b76b__"